<template>
  <div>
    <el-form
      label-position="top"
      :model="image"
      :rules="rules"
      ref="imageForm"
    >
      <el-form-item
        label=""
        prop="is_primary"
        style="margin-top: -20px;"
      >
        <el-switch
          v-model="image.is_primary"
          active-text="Elsődleges"
        />
      </el-form-item>
      <el-form-item
        label="Leírás"
        prop="description"
      >
        <el-input
          v-model="image.description"
          type="textarea"
        />
      </el-form-item>
      <el-upload
        :key="uploadKey"
        action=""
        class="file-uploader"
        :show-file-list="false"
        :on-change="handleImageChange"
        :auto-upload="false"
        :limit="1"
        :disabled="isDisabled"
      >
        <img v-if="image.image.full" :src="image.image.full" class="avatar">
        <i v-else class="el-icon-plus file-uploader-icon"></i>
      </el-upload>
    </el-form>
  </div>
</template>

<script>
  export default {
    props: ['defaultImage', 'formType'],
    data() {
      return {
        image: {
          image: {
            file: null,
          }
        },
        uploadKey: 0,
        rules: {},
      };
    },
    computed: {
      isDisabled() {
        if (this.image.image.full) {
          return true;
        }
        return false;
      }
    },
    watch: {
      defaultImage: {
        handler(newVal) {
          this.image = JSON.parse(JSON.stringify(newVal));
        },
        deep: true,
      },
    },
    async mounted() {
      await this.$store.dispatch('packType/fetchAll');
      if (this.formType === 'add') {
        this.image = {
          image: {
            file: null,
          }
        };
      } else {
        this.image = JSON.parse(JSON.stringify(this.defaultImage));
      }
    },
    methods: {


      async handleImageChange(file) {
        if (this.isImageCorrect(file)) {
          this.image.image.full = URL.createObjectURL(file.raw);
          this.image.image.file = await this.getBase64(file.raw);
          this.uploadKey++;
        } else {
          this.uploadKey++;
        }
      },

      isImageCorrect(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isLt2M) {
          this.$messageWrapper.error('Kép mérete nem lehet nagyobb, mint 10MB!');
          return isLt2M;
        }
        return isLt2M;
      },

      getBase64(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        return new Promise((resolve, reject) => {
          reader.onload = function() {
            resolve(reader.result);
          };
          reader.onerror = function(error) {
            console.log(error);
            reject(error);
          };
        });
      },
    }
  };
</script>
<style>
  .file-uploader .el-upload .el-upload-dragger {
    width: 100%;
  }

  .file-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .file-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .file-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: 178px;
    display: block;
    object-fit: contain;
  }
</style>
